import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { OfferType, SubType } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonFifthVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant5',
  styleUrl: './variant5.component.scss',
  templateUrl: './variant5.component.html',
  imports: [SafePipe, RewardPipe, ButtonComponent, VariableReplacementPipe],
})
export class Variant5Component extends SelectionButtonBaseClass {
  protected readonly OfferType: typeof OfferType = OfferType;
  protected readonly SubType = SubType;
  config = input.required<SelectionButtonFifthVariantConfig>();
}
